module.exports = __webpack_public_path__ + "f2ab0ff064635398578dfbaf2d400ef2.png";